import React, { useContext, useEffect, useState } from 'react'
import './ShribetsMarket.css'
import CurrentDayTime from '../14-currentDate/CurrentDayTime'
import { useNavigate } from 'react-router-dom'
import Navbar from '../01-navbar/Navbar'
import axios from 'axios'
import { LoaderContext } from '../15-loader/LoaderProvider'
import Loader from '../15-loader/Loader'

const ShribetsMarket = () => {

    const navigate = useNavigate()

    const [marketApiData, setMarketApiData] = useState([]);

    const { setIsLoading } = useContext(LoaderContext);
    const { isLoading } = useContext(LoaderContext);

    const getMarket = async () => {
        await axios.get(`${process.env.REACT_APP_BASE_URL}/web/getMarkets`)
            .then((r) => {
                setMarketApiData(r.data.data)
                setIsLoading(false)
            })
            .catch((err) => console.log(err.message));
    }



    useEffect(() => {

        getMarket()

    }, []);

    return (
        <>
            <div className='shribet-navbar'><Navbar /></div>

            {/* {
                isLoading ? <Loader/> :  */}


            <div className='shribet-market'>

                <div className='shribet-market-content'>

                    <div className='container'>

                        <div className='shribet-market-heading'><h2>Lata 777 MARKET RESULT</h2></div>   

                        <div className='shribet-market-chart-buttons'>

                            <ul className="shribet-market-chart-button-tab nav nav-pills mb-3" id="pills-tab" role="tablist">

                                <li className="nav-item" role="presentation" >
                                    <button className="shribet-market-pana-chart nav-link active" id="pills-home-tab" data-bs-toggle="pill" data-bs-target="#pills-home" type="button" role="tab" aria-controls="pills-home" aria-selected="true">PANA CHART</button>
                                </li>

                                <li className=" nav-item" role="presentation" >
                                    <button className="shribet-market-jodi-chart nav-link" id="pills-profile-tab" data-bs-toggle="pill" data-bs-target="#pills-profile" type="button" role="tab" aria-controls="pills-profile" aria-selected="false">JODI CHART</button>
                                </li>

                            </ul>

                            <div className="tab-content" id="pills-tabContent">

                                <div className="tab-pane fade show active" id="pills-home" role="tabpanel" aria-labelledby="pills-home-tab">

                                    <div className='shribets-market-boxes'>

                                        {
                                            marketApiData.map((data) =>

                                                <div className='shribets-result-box' key={data.MarketId} onClick={() => navigate(`/market-result/panachart/${data.MarketId}`)}>
                                                    <div className='shribets-market-box-heading'><h2>{data.Market}</h2></div>
                                                </div>

                                            )
                                        }

                                        {/* <div className='shribets-result-box'>
                                                    <div className='shribets-market-box-heading'><h2>SRIDEVI</h2></div>
                                                </div>
                                                <div className='shribets-result-box'>
                                                    <div className='shribets-market-box-heading'><h2>TIME BAZAR</h2></div>
                                                </div>
                                                <div className='shribets-result-box'>
                                                    <div className='shribets-market-box-heading'><h2>MADHUR DAY</h2></div>
                                                </div>
                                                <div className='shribets-result-box'>
                                                    <div className='shribets-market-box-heading'><h2>MILAN DAY</h2></div>
                                                </div>
                                                <div className='shribets-result-box'>
                                                    <div className='shribets-market-box-heading'><h2>RAJDHANI DAY</h2></div>
                                                </div>
                                                <div className='shribets-result-box'>
                                                    <div className='shribets-market-box-heading'><h2>SUPREME DAY</h2></div>
                                                </div>
                                                <div className='shribets-result-box'>
                                                    <div className='shribets-market-box-heading'><h2>KALYAN</h2></div>
                                                </div>
                                                <div className='shribets-result-box'>
                                                    <div className='shribets-market-box-heading'><h2>SRIDEVI NIGHT</h2></div>
                                                </div>
                                                <div className='shribets-result-box'>
                                                    <div className='shribets-market-box-heading'><h2>SUPREME NIGHT</h2></div>
                                                </div>
                                                <div className='shribets-result-box'>
                                                    <div className='shribets-market-box-heading'><h2>MILAN NIGHT</h2></div>
                                                </div>
                                                <div className='shribets-result-box'>
                                                    <div className='shribets-market-box-heading'><h2>RAJDHANI NIGHT</h2></div>
                                                </div>
                                                <div className='shribets-result-box'>
                                                    <div className='shribets-market-box-heading'><h2>RAJDHANI NIGHT</h2></div>
                                                </div>
                                                <div className='shribets-result-box'>
                                                    <div className='shribets-market-box-heading'><h2>RAJDHANI NIGHT</h2></div>
                                                </div> */}

                                    </div>

                                </div>

                                <div className="tab-pane fade" id="pills-profile" role="tabpanel" aria-labelledby="pills-profile-tab">

                                    <div className='shribets-market-boxes'>

                                        {
                                            marketApiData.map((data, index) =>

                                                <div className='shribets-result-box' key={index} onClick={() => navigate(`/market-result/jodichart/${data.MarketId}`)}>
                                                    <div className='shribets-market-box-heading'><h2>{data.Market}</h2></div>
                                                </div>

                                            )
                                        }

                                        {/* <div className='shribets-result-box' onClick={() => navigate('/market-result/jodichart')}>
                                                    <div className='shribets-market-box-heading'><h2>MILAN MORNING</h2></div>
                                                </div>
                                                <div className='shribets-result-box'>
                                                    <div className='shribets-market-box-heading'><h2>SRIDEVI</h2></div>
                                                </div>
                                                <div className='shribets-result-box'>
                                                    <div className='shribets-market-box-heading'><h2>TIME BAZAR</h2></div>
                                                </div>
                                                <div className='shribets-result-box'>
                                                    <div className='shribets-market-box-heading'><h2>MADHUR DAY</h2></div>
                                                </div>
                                                <div className='shribets-result-box'>
                                                    <div className='shribets-market-box-heading'><h2>MILAN DAY</h2></div>
                                                </div>
                                                <div className='shribets-result-box'>
                                                    <div className='shribets-market-box-heading'><h2>RAJDHANI DAY</h2></div>
                                                </div>
                                                <div className='shribets-result-box'>
                                                    <div className='shribets-market-box-heading'><h2>SUPREME DAY</h2></div>
                                                </div>
                                                <div className='shribets-result-box'>
                                                    <div className='shribets-market-box-heading'><h2>KALYAN</h2></div>
                                                </div>
                                                <div className='shribets-result-box'>
                                                    <div className='shribets-market-box-heading'><h2>SRIDEVI NIGHT</h2></div>
                                                </div>
                                                <div className='shribets-result-box'>
                                                    <div className='shribets-market-box-heading'><h2>SUPREME NIGHT</h2></div>
                                                </div>
                                                <div className='shribets-result-box'>
                                                    <div className='shribets-market-box-heading'><h2>MILAN NIGHT</h2></div>
                                                </div>
                                                <div className='shribets-result-box'>
                                                    <div className='shribets-market-box-heading'><h2>RAJDHANI NIGHT</h2></div>
                                                </div>
                                                <div className='shribets-result-box'>
                                                    <div className='shribets-market-box-heading'><h2>RAJDHANI NIGHT</h2></div>
                                                </div>
                                                <div className='shribets-result-box'>
                                                    <div className='shribets-market-box-heading'><h2>RAJDHANI NIGHT</h2></div>
                                                </div> */}

                                    </div>

                                </div>

                            </div>

                        </div>

                    </div>

                </div>

            </div>

            {/* } */}


        </>
    )
}

export default ShribetsMarket
